import React from 'react';
import { HistoryVersionFlowProjectComponent } from 'components/admin/flows/elements/Projects/HistoryVersionFlowProject';
import { FlexContainer } from 'styles/FlexContainer';
import { ModalComponentType } from 'store/reducers/modals/types';

interface RollBackFlowProjectModalProps {
  projectId: string;
  projectName?: string;
}

export const RollBackFlowProjectModal: ModalComponentType<RollBackFlowProjectModalProps> = ({
  projectId,
  projectName,
  onClose,
}) => {
  return (
    <FlexContainer width="100%" height="100%" overflowY="auto">
      <FlexContainer width="100%" flexDirection="column" height="calc(-120px + 420px)" overflowY="auto" marginBottom="60px">
        <HistoryVersionFlowProjectComponent
          padding="0"
          footerPosition="flex-end"
          projectId={projectId}
          projectName={projectName}
          onClose={onClose}
        />
      </FlexContainer>
    </FlexContainer>
  );
};
